import React from 'react';

import Info from '@sats-group/icons/18/info';

import type { InformationRow as Props } from './information-row.types';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

const InformationRow: React.FunctionComponent<Props> = ({ text }) => (
  <div className="information-row">
    <Info />
    <Text size={Text.sizes.small}>{text}</Text>
  </div>
);

export default InformationRow;
